/**
 * @fileoverview Record resolution and settlement context through the matter-attribute boundary. The backend owns accepted values and the parent refreshes their projection. Recording an outcome is separate from provider payment settlement, notification delivery, or broader automatic matter transitions.
 */

import { useContext, useEffect, useState } from "react"
import { AppButton, AppModal, AppCurrencyInput } from '../shared'
import ToastContext from '../../ToastContext'
import api from "../../api"
import { useSelector } from "react-redux"



function ResolvedAttributeForm({ visible, setVisible, attributes, fetchAttributes }) {
    const matter = useSelector(state => state.caseDetails.matter)
    const showToast = useContext(ToastContext)
    const [grossReceived, setGrossReceived] = useState(null)
    const [clientReceived, setClientReceived] = useState(null)
    const [feesRecovered, setFeesRecovered] = useState(null)
    const [costsRecovered, setCostsRecovered] = useState(null)

    useEffect(() => {
        if (attributes && attributes.length > 0) {
            const findAttribute =

            (name) => {
                const attr = attributes.find(attribute => attribute.Attribute === name)
                return attr ? attr.Value : null;
            };

            setGrossReceived(findAttribute('Gross Received'));
            setClientReceived(findAttribute('Client Received'));
            setFeesRecovered(findAttribute('Fees Recovered'));
            setCostsRecovered(findAttribute('Costs Recovered'));
        }
    }, [attributes]);


    const submit =

    () => {
        console.log('submit')
        const payload = {
            'Gross Received': grossReceived,
            'Client Received': clientReceived,
            'Fees Recovered': feesRecovered,
            'Costs Recovered': costsRecovered,
            MatterNumber: matter.MatterNumber,
        }

        api.post('/resolution_attributes', payload)
            .then(

            response => {
                console.log(response.data)
                fetchAttributes()
                showToast({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Resolution Attributes Saved'
                })
                setVisible(false)
            })
            .catch(error => {
                console.error('Error:', error)
                showToast({ severity: 'error', summary: 'Error', detail: error.message })
            })
    }

    const footerContent = (
        <div className="case-details-modal__actions">
            <AppButton
                label="Save"
                icon="pi pi-check"
                onClick={submit}
                autoFocus
                disabled={[grossReceived, clientReceived, feesRecovered, costsRecovered].every((value) => value === null)}
            />
        </div>
    )

    return (
        <>
            <AppModal
                title='Resolution Attributes'
                description="Capture the final settlement amounts that should remain attached to this matter."
                visible={visible}
                onClose={() => setVisible(false)}
                width="min(92vw, 760px)"
                footer={footerContent}
                className="case-details-modal"
            >
                <div className="case-details-modal__form">
                    <section className="case-details-modal__section">
                        <div className="case-details-modal__section-header">
                            <div>
                                <h3 className="case-details-modal__section-title">Settlement Totals</h3>
                                <p className="case-details-modal__section-description">
                                    Record the final incoming and allocated amounts that define the resolved value of the case.
                                </p>
                            </div>
                        </div>
                        <div className="case-details-modal__section-body">
                            <div className="case-details-modal__grid">
                                <div className="case-details-modal__field">
                                    <label className="case-details-modal__label">Gross Received</label>
                                    <AppCurrencyInput value={grossReceived} onValueChange={(e) => setGrossReceived(e.value)} />
                                </div>
                                <div className="case-details-modal__field">
                                    <label className="case-details-modal__label">Client Received</label>
                                    <AppCurrencyInput value={clientReceived} onValueChange={(e) => setClientReceived(e.value)} />
                                </div>
                                <div className="case-details-modal__field">
                                    <label className="case-details-modal__label">Fees Recovered</label>
                                    <AppCurrencyInput value={feesRecovered} onValueChange={(e) => setFeesRecovered(e.value)} />
                                </div>
                                <div className="case-details-modal__field">
                                    <label className="case-details-modal__label">Costs Recovered</label>
                                    <AppCurrencyInput value={costsRecovered} onValueChange={(e) => setCostsRecovered(e.value)} />
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </AppModal>
        </>
    )

}

export default ResolvedAttributeForm
